export default {
  calculatorCommunities: [],
  applicationCommunities: []
}
